import { render, staticRenderFns } from "./Input-fields.vue?vue&type=template&id=4097e902&scoped=true&"
import script from "./Input-fields.vue?vue&type=script&lang=js&"
export * from "./Input-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4097e902",
  null
  
)

export default component.exports